function load_script(e){let o=document.createElement("script");o.src=e,o.defer=!0,o.onload=()=>{console.log("Script loaded successfuly");let e=document.getElementById("box");e.textContent="The script has loaded."},o.onerror=()=>{console.log("Error occurred while loading script")},document.body.appendChild(o)}

window.onload = function(){
load_script("https://www.youtube.com/iframe_api")
}   

const mainBanners = document.querySelectorAll('[data-main-image="true"]');
console.log(mainBanners.length)
if(mainBanners.length > 0){
  mainBanners.forEach(mainBanner => {
    const mediaQuery = window.matchMedia('(min-width: 768px)')
    const mobileBanner = mainBanner.querySelector(".image-hero__image--mobile img")
    const desktopBanner = mainBanner.querySelector(".image-hero__image-desktop img")
    if (mediaQuery.matches) {
      if(mobileBanner != null){
        mobileBanner.setAttribute("loading", "lazy")
      }
      if(mobileBanner != null){
        desktopBanner.removeAttribute("loading")
      }
    }else{
      if(mobileBanner != null){
        desktopBanner.setAttribute("loading", "lazy")
      }
      if(mobileBanner != null){
        mobileBanner.removeAttribute("loading")
      }
    }
  })
}